export class ApiError extends Error {
    constructor(error) {
        super();
        this.message = `${error.status} ${error.statusText}`;
        this.status = error.status;
        this.statusText = error.statusText;
        this.response = error.response;
    }
}
